import { gql } from '@apollo/client';

export const CREATE_ORDER_MUTATION = gql`
  mutation CreateOrder($input: CreateOrderInput!) {
    createOrder(input: $input) {
      id
      orderNo
      orderStatus
      orderAmount
      finalAmount
      paymentTerms
      remittanceTranches {
        percentage
        amount
        dueDate
        milestone
      }
      customer {
        firstName
        lastName
        email
        phone
      }
      items {
        id
        productName
        quantity
        unitPrice
        totalPrice
      }
      shipments {
        id
        carrier
        shippingStatus
        trackingNumber
      }
    }
  }
`;

// TypeScript types for the mutation
export interface CustomerInput {
  email: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  streetAddress?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
}

export interface VendorInput {
  name: string;
  email: string;
  phoneNumber?: string;
  firstName?: string;
  lastName?: string;
  country?: string;
}

export interface OrderItemInput {
  productId?: number;
  productName: string;
  quantity: number;
  unitPrice: number;
  itemDetails?: string;
  unit?: string;
  hsCode?: string;
  category?: string;
  declaredValue?: number;
  countryOfOrigin?: string;
  exportControlFlag?: string;
  ecgcEligibility?: string;
}

export interface ShipmentInput {
  carrier?: string;
  packageType?: string;
  weight?: number;
  dimensions?: string;
  origin?: string;
  destination?: string;
  estimatedArrivalDate?: string;
  pickupCity?: string;
  pickupState?: string;
  pickupCountry?: string;
  pickupPostalCode?: string;
  deliveryCity?: string;
  deliveryState?: string;
  deliveryCountry?: string;
  deliveryPostalCode?: string;
}

export interface RemittanceTrancheInput {
  percentage: number;
  dueDate?: string;
  milestone?: string;
}

export interface CreateOrderInput {
  customer: CustomerInput;
  vendor: VendorInput;
  items: OrderItemInput[];
  shipment?: ShipmentInput;
  remittanceTranches?: RemittanceTrancheInput[];
  currency?: string;
  incoterms?: string;
  salesPerson?: string;
  poNumber?: string;
  paymentTerms?: string;
  subtotal?: number;
  taxPercent?: number;
  taxAmount?: number;
  discountPercentage?: number;
  discountAmount?: number;
  finalAmount?: number;
  orderAmount?: number;
  priorityLevel?: string;
  specialInstructions?: string;
  insuranceRequired?: boolean;
  customsDocsRequired?: boolean;
  destinationCountry?: string;
  sourceDocumentUrl?: string;
  sourceDocumentName?: string;
}

export interface OrderItemResponse {
  id: number;
  productName: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
}

export interface ShipmentResponse {
  id: number;
  carrier?: string;
  shippingStatus: number;
  trackingNumber?: string;
}

export interface CreateOrderResponse {
  id: number;
  orderNo?: string;
  orderStatus: number;
  orderAmount: number;
  finalAmount: number;
  remittanceTranches?: Array<{
    percentage: number;
    amount: number;
    dueDate?: string;
    milestone?: string;
  }>;
  customer: CustomerInput;
  items: OrderItemResponse[];
  shipments?: ShipmentResponse[];
}

export interface CreateOrderData {
  createOrder: CreateOrderResponse;
}

export interface CreateOrderVariables {
  input: CreateOrderInput;
}
